
export const FIRST_TIME_LOAD = (state, value) => {
  state.firstTimeLoad = value
}

export const QUOTE_FOR_TABS = (state, value) => {
  state.quoteForTabs = value
}

export const QUOTE_VERSIONS_FOR_TAB = (state, value) => {
  state.quoteVersionsForTab = value
}

export const QUOTE_ACTIVITIES_FOR_TAB = (state, value) => {
  state.quoteActivitiesForTab = value
}

export const QUOTE_ATTACHMENTS_FOR_TAB = (state, value) => {
  state.quoteAttachmentForTab = value
}

export const QUOTE_HISTORY_FOR_TAB = (state, value) => {
  state.quoteHistoryForTab = value
}

export const MAIN_LIST_SAVED_FILTER = (state, value) => {
  state.mainListSavedFilter = value
}

export const MAIN_LIST_QUICK_FILTER = (state, value) => {
  state.mainListQuickFilters = value
}

export const QUICK_FILTERS_DATES_FROM = (state, value) => {
  state.quickFiltersDatesFrom = value
}

export const QUICK_FILTERS_DATES_TO = (state, value) => {
  state.quickFiltersDatesTo = value
}

export const SORT = (state, { sortField, sortFieldId, sortOrder }) => {
  state.sortField = sortField
  state.sortFieldId = sortFieldId
  state.sortOrder = sortOrder
}

export const PAGE = (state, { page, rows }) => {
  state.page = page
  state.rows = rows
}

export const HARD_LOAD = (state, value) => {
  state.hardLoad = value
}

export const SOFT_RELOAD = (state, value) => {
  state.softReload = value
}